import React from 'react'
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/store/rootReducer';
import { List, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { removeOrificeSize } from './orificeSizeSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';

export default function OrificeSizeList(): JSX.Element {
    const dispatch = useDispatch();
    const { setModelChange, messageApi, setEditBodySize } = React.useContext(CommonContext) as CommonContextType;
    const OrificeSizes = useSelector(
      (state: AppState) => state.OrificeSizes
    );
    const showModal = (record?: any) => {
      if (record.id) {
        setEditBodySize(record)
        setModelChange(true)
      }
    };
    const handleDelete = (id: number) => {
      dispatch(removeOrificeSize(id));
      /* messageApi.open({
        type: 'success',
        content: 'Orifice Size deleted successfully',
      }); */
    };
    return (
        <List 
          className="demo-loadmore-list"
          itemLayout="horizontal"
          dataSource={OrificeSizes}
          renderItem={(item: any, index) => (
            <List.Item key={item.id}
              actions={[
                <EditOutlined style={{ color: '#018B98' }} onClick={() => showModal(item)} />,
                <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(item.id)}>
                  <DeleteOutlined style={{ color: 'red' }} />
                </Popconfirm>]}>
    
              <div className='main_class'>
                <p className='sub_data'><b>Value:</b> {item.orificesize_value} </p>
              </div>
            </List.Item>
          )}
        />
      );
}